import React from 'react'
import { Box, Typography } from '@mui/material'
import { LEGEND_TEXT_COLOR_MAP } from '../../../../../constants'
import {
  LegendContainer,
  LegendItem,
  LegendColor
} from './style'

const ChartLegend = ({ data, type = 'brand' }) => {
  if (type === 'default') {
    const defaultLegend = [
      { label: 'Positive', color: '#000', bgColor: LEGEND_TEXT_COLOR_MAP.Positive },
      { label: 'Negative', color: '#000', bgColor: LEGEND_TEXT_COLOR_MAP.Negative },
      { label: 'Mixed', color: '#000', bgColor: '#7c868f' }
    ]

    return (
      <LegendContainer>
        {defaultLegend.map((item, idx) => (
          <LegendItem key={idx}>
            <LegendColor color={item.color} bgColor={item.bgColor} textColor='white' type={type} />
            <Typography variant='caption' sx={{ fontSize: '12px', fontWeight: 500 }}>
              {item.label}
            </Typography>
          </LegendItem>
        ))}
      </LegendContainer>
    )
  }

  if (type === 'brand') {
    if (!data || data.length === 0) return null

    return (
      <LegendContainer className='chartLegendWrapper'>
        {data.map((item, idx) => {
          const color = '#333333'
          const initials = item.logoName.substring(0, 2).toUpperCase()
          return (
            <LegendItem key={idx}>
              <LegendColor color={color} type={type}>{initials}</LegendColor>
              <Typography variant='caption' sx={{ fontSize: '12px', fontWeight: 400 }}>
                {item.logoName}
              </Typography>
            </LegendItem>
          )
        })}
      </LegendContainer>
    )
  }

  return null
}

export default ChartLegend
